import { useState } from "react";

const FAQItem = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 pb-4">
      <button
        className="flex justify-between items-center w-full text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h4 className="text-[1.25rem] md:text-[1.125rem] fontNew font-bold">
          {faq.question}
        </h4>
        <span className="text-2xl">{isOpen ? "-" : "+"}</span>
      </button>
      <div
        className={`mt-2 text-gray-700 transition-max-height duration-500 ease-in-out overflow-hidden ${
          isOpen ? "max-h-72" : "max-h-0"
        }`}
      >
        <div dangerouslySetInnerHTML={{ __html: faq?.answer }} />
        {faq?.list ? (
          <ul className="flex flex-col space-y-2 mt-2">
            {faq?.list?.map((item) => (
              <li key={item}>{`• ${item}`}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
};

export default FAQItem;
